// // import "../styles/About.css";

// // export default function About() {
// //   return (
// //     <section className="about-page">

// //       {/* HERO SECTION */}
// //       <div className="about-hero">

// //         <div className="container">

// //           <span className="about-badge">
// //             JAT TECHNOCRAFT GROUP
// //           </span>

// //           <h1>
// //             Building Industrial Excellence Since 1992
// //           </h1>

// //           <p>
// //             A leading manufacturing group specializing in metal pressing,
// //             steel processing, and engineering solutions across India.
// //           </p>

// //         </div>

// //       </div>

// //       {/* CONTENT */}
// //       <div className="container">

// //         <div className="about-grid">

// //           <div className="about-card">
// //             <h3>JAT Metal Pressing Pvt. Ltd.</h3>
// //             <p className="location">K-10 MIDC Waluj, Aurangabad</p>
// //             <p><b>Established:</b> 1992</p>
// //             <p><b>Turnover:</b> ₹48 Crore</p>
// //           </div>

// //           <div className="about-card">
// //             <h3>Essaa Syntex Pvt. Ltd.</h3>
// //             <p className="location">Rustampur, Kashipur, Uttarakhand</p>
// //             <p><b>Established:</b> 2011</p>
// //             <p><b>Turnover:</b> ₹12 Crore</p>
// //           </div>

// //           <div className="about-card">
// //             <h3>MITA Engineering Unit</h3>
// //             <p className="location">Taloja MIDC, Mumbai</p>
// //             <p><b>Established:</b> 1998</p>
// //             <p><b>Turnover:</b> ₹50 Crore</p>
// //           </div>

// //           <div className="about-card highlight-card">
// //             <h3>GRV Steel Ltd.</h3>
// //             <p className="location">Murbad MIDC, Mumbai</p>
// //             <p><b>Established:</b> 2015</p>
// //             <p><b>Turnover:</b> ₹90 Crore</p>
// //             <span className="tag">Authorized JSW Centre</span>
// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }






































// import "../styles/About.css";

// export default function About() {
//   return (
//     <section className="about-page">

//       {/* HERO SECTION */}
//       <div className="about-hero">

//         <div className="container">

//           <span className="about-badge">
//             JAT TECHNOCRAFT GROUP
//           </span>

//           <h1>
//             Building Industrial Excellence Since 1992
//           </h1>

//           <p>
//             A leading manufacturing group specializing in metal pressing,
//             steel processing, and engineering solutions across India.
//           </p>

//         </div>

//       </div>

//       {/* CONTENT */}
//       <div className="container">

//         <div className="about-grid">

//           {/* CARD 1 */}
//           <div className="about-card">

//             <h3>JAT Metal Pressing Pvt. Ltd.</h3>

//             <a
//               href="https://maps.google.com/?q=K-10+MIDC+Waluj+Aurangabad"
//               target="_blank"
//               rel="noreferrer"
//               className="location"
//             >
//               K-10 MIDC Waluj, Aurangabad
//             </a>

//             <p><b>Established:</b> 1992</p>
//             <p><b>Turnover:</b> ₹48 Crore</p>

//           </div>

//           {/* CARD 2 */}
//           <div className="about-card">

//             <h3>Essaa Syntex Pvt. Ltd.</h3>

//             <a
//               href="https://maps.google.com/?q=Rustampur+Kashipur+Uttarakhand"
//               target="_blank"
//               rel="noreferrer"
//               className="location"
//             >
//               Rustampur, Kashipur, Uttarakhand
//             </a>

//             <p><b>Established:</b> 2011</p>
//             <p><b>Turnover:</b> ₹12 Crore</p>

//           </div>

//           {/* CARD 3 */}
//           <div className="about-card">

//             <h3>MITA Engineering Unit</h3>

//             <a
//               href="https://maps.google.com/?q=Taloja+MIDC+Mumbai"
//               target="_blank"
//               rel="noreferrer"
//               className="location"
//             >
//               Taloja MIDC, Mumbai
//             </a>

//             <p><b>Established:</b> 1998</p>
//             <p><b>Turnover:</b> ₹50 Crore</p>

//           </div>

//           {/* CARD 4 */}
//           <div className="about-card highlight-card">

//             <h3>GRV Steel Ltd.</h3>

//             <a
//               href="https://maps.google.com/?q=Murbad+MIDC+Mumbai"
//               target="_blank"
//               rel="noreferrer"
//               className="location"
//             >
//               Murbad MIDC, Mumbai
//             </a>

//             <p><b>Established:</b> 2015</p>
//             <p><b>Turnover:</b> ₹90 Crore</p>

//             <span className="tag">
//               Authorized JSW Centre
//             </span>

//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }






import "../styles/About.css";

export default function About() {
  return (
    <section className="about-page">

      {/* HERO SECTION */}
      <div className="about-hero">

        <div className="container">

          <span className="about-badge">
            JAT TECHNOCRAFT GROUP
          </span>

          <h1>
            Building Industrial Excellence Since 1992
          </h1>

          <p>
            A leading manufacturing group specializing in metal pressing,
            steel processing, and engineering solutions across India.
          </p>

        </div>

      </div>

      {/* CONTENT */}
      <div className="container">

        <div className="about-grid">

          {/* CARD 1 */}
          <div className="about-card">

            <h3>JAT Metal Pressing Pvt. Ltd.</h3>

            <a
              href="https://maps.google.com/?q=K-10+MIDC+Waluj+Aurangabad"
              target="_blank"
              rel="noreferrer"
              className="location"
            >
              K-10 MIDC Waluj, Chhatrapati Sambhajinagar
            </a>

            <p><b>Established:</b> 1992</p>
            <p><b>Turnover:</b> ₹48 Crore</p>

          </div>

          {/* CARD 2 */}
          <div className="about-card">

            <h3>Essaa Syntex Pvt. Ltd.</h3>

            <a
              href="https://maps.google.com/?q=Rustampur+Kashipur+Uttarakhand"
              target="_blank"
              rel="noreferrer"
              className="location"
            >
              Rustampur, Kashipur, Uttarakhand
            </a>

            <p><b>Established:</b> 2011</p>
            <p><b>Turnover:</b> ₹12 Crore</p>

          </div>

          {/* CARD 3 */}
          <div className="about-card">

            <h3>MITA Engineering Unit</h3>

            <a
              href="https://maps.google.com/?q=Taloja+MIDC+Mumbai"
              target="_blank"
              rel="noreferrer"
              className="location"
            >
              Taloja MIDC, Mumbai
            </a>

            <p><b>Established:</b> 1998</p>
            <p><b>Turnover:</b> ₹50 Crore</p>

          </div>

          {/* CARD 4 (HIGHLIGHT / GLASS PREMIUM) */}
          <div className="about-card highlight-card">

            <h3>GRV Steel Ltd.</h3>

            <a
              href="https://maps.google.com/?q=Murbad+MIDC+Mumbai"
              target="_blank"
              rel="noreferrer"
              className="location"
            >
              Murbad MIDC, Mumbai
            </a>

            <p><b>Established:</b> 2015</p>
            <p><b>Turnover:</b> ₹90 Crore</p>

            <span className="tag">
              Authorized JSW Centre
            </span>

          </div>

        </div>

      </div>

    </section>
  );
}